import axios from "axios";
import authHeader from '../../../authheader'

const LSIRENEWALURL = process.env.REACT_APP_APIURL + "/api/IndividualLsiRenewal";



const getBoardRecommendations = (renewalId) => {
    return axios.get(`${LSIRENEWALURL}/boardrecommendations`, { headers: authHeader(), params: { renewalId } });
}
const getBoardResponses = (renewalId) => {
    return axios.get(`${LSIRENEWALURL}/boardmemberresponses`, { headers: authHeader(), params: { renewalId } });
}
const postBoardRecommendation = (data) => {
    return axios.post(`${LSIRENEWALURL}/boardrecommendation`, data, { headers: authHeader() });
}
const postBoardResponse = (data) => {
    var header = authHeader();
    header['Content-Type'] = 'multipart/form-data';
    return axios.post(`${LSIRENEWALURL}/boardmemberresponse`, data, { headers: { ...header } });
}
export default {
    getBoardRecommendations,
    getBoardResponses,
    postBoardRecommendation,
    postBoardResponse
}